import { FC } from "react";
import { HR, StatParameterContent, StatParameterName, StatParameterValue } from "./styled";
import CountUp from "react-countup";

interface StatParameterProps {
    name: string;
    value: number;
    nameSize?: number;
}
export const StatParameter: FC<StatParameterProps> = ({ name, value, nameSize = 24 }) => {
    return (
        <div className="flex flex-col justify-center items-center rounded-full text-slate-950 bg-slate-200 w-28 h-28 sm:min-w-[140px] sm:min-h-[140px]">
            <StatParameterContent>
                <StatParameterName $size={nameSize}>
                    {name}
                </StatParameterName>
                <HR />
                <StatParameterValue>
                    <CountUp redraw end={value} enableScrollSpy scrollSpyOnce/>
                </StatParameterValue>
            </StatParameterContent>
        </div>
    );
}